import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative hidden group-hover/navItem:block cursor-default"
}
const _hoisted_2 = {
  class: /*@__PURE__*/_normalizeClass([
          'absolute left-1/2 -translate-x-1/2 top-2',
          'bg-tile p-2 font-medium space-y-2',
          'border rounded-lg border-tile-border',
        ])
}

import {computed} from "vue";
import Button from "../../../../DesignSystem/Button.vue";
import {NavigationAction} from "../../../Port/NavigationService";
import {useNavigationStore} from "../../navigationStore";
import {NavigationItem} from "../../Presenter/entryPointItems";
import {useNavigationService} from "../../vue";
import ForumMenu from "../ForumMenuDesktop.vue";
import NavigationLink from "../NavigationLink.vue";

const navigationLinkStyle = 'max-lg:hidden py-2 px-1 xl:px-3 rounded';

interface Emit {
  (event: 'action', action: NavigationAction): void;
}

interface Props {
  type: 'link'|'buttonSecondary'|'space';
  title?: string;
  forumMenu?: boolean;
  action?: NavigationAction;
  children?: NavigationItem[];
  childrenForNotAuthenticated?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'NavTopbarListItem',
  props: {
    type: {},
    title: {},
    forumMenu: { type: Boolean },
    action: {},
    children: {},
    childrenForNotAuthenticated: { type: Boolean }
  },
  emits: ['action'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const store = useNavigationStore();
const service = useNavigationService();

function action(action: NavigationAction): void {
  emit('action', action);
}

function invokeAction(): void {
  action(props.action);
}

const includeChildren = computed<boolean>(() => {
  if (props.childrenForNotAuthenticated && store.isAuthenticated) {
    return false;
  }
  return props.children?.length > 0;
});

return (_ctx: any,_cache: any) => {
  return (props.type === 'link')
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (props.forumMenu)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["group/navItem", _ctx.$attrs.class])
            }, [
              _createVNode(NavigationLink, {
                class: _normalizeClass([navigationLinkStyle, "group-hover/navItem:text-green2-500"]),
                textContent: _toDisplayString(props.title),
                action: props.action,
                onAction: action
              }, null, 8 /* PROPS */, ["textContent", "action"]),
              _createVNode(ForumMenu)
            ], 2 /* CLASS */))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass([[navigationLinkStyle, _ctx.$attrs.class], "whitespace-nowrap group/navItem"])
            }, [
              _createVNode(NavigationLink, {
                class: "block hover:text-green2-500",
                textContent: _toDisplayString(props.title),
                action: props.action,
                onAction: action
              }, null, 8 /* PROPS */, ["textContent", "action"]),
              (includeChildren.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.children, (child) => {
                        return (_openBlock(), _createBlock(NavigationLink, {
                          class: "block hover:text-green2-500 p-2 cursor-pointer",
                          textContent: _toDisplayString(child.title),
                          action: child.action,
                          onAction: ($event: any) => (action(child.action))
                        }, null, 8 /* PROPS */, ["textContent", "action", "onAction"]))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */))
      ], 64 /* STABLE_FRAGMENT */))
    : (props.type === 'buttonSecondary')
      ? (_openBlock(), _createBlock(Button, {
          key: 1,
          class: _normalizeClass(["text-base h-10 leading-6", _ctx.$attrs.class]),
          "primary-outline": "",
          title: props.title,
          onClick: invokeAction
        }, null, 8 /* PROPS */, ["class", "title"]))
      : (props.type === 'space')
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(["mr-auto", _ctx.$attrs.class])
          }, null, 2 /* CLASS */))
        : _createCommentVNode("v-if", true)
}
}

})